const emailRegexp = new RegExp(
  // eslint-disable-next-line no-useless-escape
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i,
);

const validateStringLength = <T extends string>(
  value: T | null,
  minLength: number,
  maxLength: number,
): boolean =>
  value !== null &&
  value.trim().length >= minLength &&
  value.trim().length <= maxLength;

export const stringLengthValidator =
  <T extends string>(minLength: number, maxLength: number) =>
  (value: T | null): boolean =>
    validateStringLength(value, minLength, maxLength);

const validateNotEmpty = <T extends string>(value: T | null) =>
  value !== null && value.trim() !== '';

export const notEmptyValidator =
  <T extends string>() =>
  (value: T | null): boolean =>
    validateNotEmpty(value);

const validateEmail = <T extends string>(value: T | null): boolean =>
  !!value && emailRegexp.test(value.trim());

export const emailValidator =
  <T extends string>(maxLength: number) =>
  (value: T | null): boolean =>
    value !== null &&
    value !== '' &&
    validateEmail(value) &&
    validateStringLength(value, 1, maxLength);
